import React, { useEffect, useState } from "react";
import InputMask from "react-input-mask";
import {
  ChoosePlanCard,
  FormField,
  FormInput,
  FormContainer,
  FormRow,
  ConfirmButton,
} from "../../styles/PreRegister";
import styled from "styled-components";
import { getCities, getUnidades } from "../../data/services/form_contract";
import { CrewStyle, WrapContent } from "../../styles/PreRegister";
import { createNewUser } from "../../data/services/enterprise_service";
import SuccessDialog from "../../components/SuccessDialog";
import ErrorDialog from "../../components/ErrorDialog";

const BlurWrapper = styled.div<{ isBlurred: boolean }>`
  filter: ${(props) => (props.isBlurred ? "blur(5px)" : "none")};
  width: 100%;
  height: 100%;
`;

export default function PreRegister() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [municipios, setMunicipios] = useState<any>([]);
  const [unidades, setUnidades] = useState<any>([]);
  const [estados, setEstados] = useState<Set<string>>(new Set());
  const [formData, setFormData] = useState({
    nome: "",
    cpf: "",
    telefone: "",
    email: "",
    dt_nascimento: "",
    cep: "",
    rua: "",
    bairro: "",
    numero: "",
    cidade: "",
    estado: "",
    unidade: "",
  });

  useEffect(() => {
    const fetchMunicipios = async () => {
      try {
        const { cities, states } = await getCities();
        setMunicipios(cities);
        setEstados(new Set(states));
      } catch (error) {
        console.error("Erro ao buscar municípios:", error);
      }
    };
    fetchMunicipios();
  }, []);

  useEffect(() => {
    const fetchUnidades = async () => {
      try {
        const { unidades } = await getUnidades();
        setUnidades(unidades);
      } catch (error) {
        console.error("Erro ao buscar unidades:", error);
      }
    };
    fetchUnidades();
  }, []);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleConfirmClick = async () => {
    if (
      !formData.nome ||
      !formData.cpf ||
      !formData.email ||
      !formData.dt_nascimento ||
      !formData.cidade ||
      !formData.estado ||
      !formData.unidade
    ) {
      alert("Preencha todos os campos obrigatórios!");
      return;
    }

    const convertDateToISO = (dateStr: string): string => {
      const cleanDate = dateStr.replace(/\D/g, "");
      if (cleanDate.length === 8) {
        const day = cleanDate.substring(0, 2);
        const month = cleanDate.substring(2, 4);
        const year = cleanDate.substring(4, 8);
        return `${year}-${month}-${day}`;
      }
      return dateStr;
    };

    const cidadeObj = municipios.find(
      (m: any) => String(m.codigo) === String(formData.cidade)
    );

    const estadoId = cidadeObj?.codigoUf ?? null;

    try {
      const response = await createNewUser(
        formData.nome,
        formData.cpf.replace(/\D/g, ""),
        formData.cep.replace(/\D/g, ""),
        formData.rua,
        formData.numero,
        "",
        formData.bairro,
        parseInt(formData.cidade),
        estadoId,
        formData.email,
        formData.telefone.replace(/\D/g, ""),
        formData.unidade,
        convertDateToISO(formData.dt_nascimento)
      );

      if (
        response &&
        (!response.statusCode ||
          response.statusCode === 200 ||
          response.statusCode === 201)
      ) {
        setIsDialogOpen(true);
      } else {
        const errorMsg = response?.message || "Erro ao cadastrar usuário.";
        setErrorMessage(errorMsg);
        setIsErrorDialogOpen(true);
      }
    } catch (error: any) {
      console.error("Erro ao cadastrar:", error);
      let errorMsg = "Erro ao cadastrar usuário. Tente novamente.";

      if (error?.message) {
        errorMsg = error.message;
      } else if (error?.response?.data?.message) {
        errorMsg = error.response.data.message;
      } else if (typeof error === "string") {
        errorMsg = error;
      }

      setErrorMessage(errorMsg);
      setIsErrorDialogOpen(true);
    }
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handleCloseErrorDialog = () => {
    setIsErrorDialogOpen(false);
    setErrorMessage("");
  };

  return (
    <CrewStyle>
      <WrapContent>
        <h1>PORTAL DO CLIENTE</h1>
        <h3>Cadastro</h3>
        <BlurWrapper isBlurred={isDialogOpen || isErrorDialogOpen}>
          <ChoosePlanCard>
            <FormContainer>
              <FormField>
                <FormInput
                  type="text"
                  name="nome"
                  placeholder="Nome Completo"
                  value={formData.nome}
                  onChange={handleInputChange}
                />
              </FormField>

              <FormField>
                <InputMask
                  mask="999.999.999-99"
                  value={formData.cpf}
                  onChange={handleInputChange}
                >
                  {(inputProps: any) => (
                    <FormInput
                      {...inputProps}
                      type="text"
                      name="cpf"
                      placeholder="CPF"
                    />
                  )}
                </InputMask>
              </FormField>

              <FormField>
                <InputMask
                  mask="(99) 99999-9999"
                  value={formData.telefone}
                  onChange={handleInputChange}
                >
                  {(inputProps: any) => (
                    <FormInput
                      {...inputProps}
                      type="tel"
                      name="telefone"
                      placeholder="Telefone"
                    />
                  )}
                </InputMask>
              </FormField>

              <FormField>
                <FormInput
                  type="email"
                  name="email"
                  placeholder="E-mail"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </FormField>

              <FormField>
                <InputMask
                  mask="99/99/9999"
                  value={formData.dt_nascimento}
                  onChange={handleInputChange}
                >
                  {(inputProps: any) => (
                    <FormInput
                      {...inputProps}
                      type="text"
                      name="dt_nascimento"
                      placeholder="Data de Nascimento (DD/MM/AAAA)"
                    />
                  )}
                </InputMask>
              </FormField>

              <FormField>
                <InputMask
                  mask="99999-999"
                  value={formData.cep}
                  onChange={handleInputChange}
                >
                  {(inputProps: any) => (
                    <FormInput
                      {...inputProps}
                      type="text"
                      name="cep"
                      placeholder="CEP"
                    />
                  )}
                </InputMask>
              </FormField>

              <FormField>
                <FormInput
                  type="text"
                  name="rua"
                  placeholder="Rua"
                  value={formData.rua}
                  onChange={handleInputChange}
                />
              </FormField>
              <FormRow>
                <FormField>
                  <FormInput
                    type="text"
                    name="bairro"
                    placeholder="Bairro"
                    value={formData.bairro}
                    onChange={handleInputChange}
                  />
                </FormField>
                <FormField>
                  <FormInput
                    type="text"
                    name="numero"
                    placeholder="Nº"
                    value={formData.numero}
                    onChange={handleInputChange}
                  />
                </FormField>
              </FormRow>
              <FormRow>
                <FormField>
                  <select
                    name="estado"
                    value={formData.estado}
                    onChange={handleInputChange}
                  >
                    <option value="" disabled>
                      Escolha o estado
                    </option>
                    {Array.from(estados).map((uf) => (
                      <option key={uf} value={uf}>
                        {uf}
                      </option>
                    ))}
                  </select>
                </FormField>
                <FormField>
                  <select
                    name="cidade"
                    value={formData.cidade}
                    onChange={handleInputChange}
                    disabled={!formData.estado}
                  >
                    <option value="" disabled>
                      Escolha a cidade
                    </option>
                    {municipios
                      .filter((m: any) => m.uf === formData.estado)
                      .map((m: any) => (
                        <option key={m.codigo} value={m.codigo}>
                          {m.nomeMunicipio}
                        </option>
                      ))}
                  </select>
                </FormField>
                <FormField>
                  <select
                    name="unidade"
                    value={formData.unidade}
                    onChange={handleInputChange}
                  >
                    <option value="" disabled>
                      Escolha a unidade
                    </option>
                    {unidades.map((u: any) => (
                      <option key={u.id_clube} value={u.id_clube}>
                        {u.razao_social}
                      </option>
                    ))}
                  </select>
                </FormField>
              </FormRow>
            </FormContainer>

            <ConfirmButton isExpanded={true} onClick={handleConfirmClick}>
              Concluir
            </ConfirmButton>
          </ChoosePlanCard>
        </BlurWrapper>
        <SuccessDialog isOpen={isDialogOpen} onClose={handleCloseDialog} />
        <ErrorDialog
          isOpen={isErrorDialogOpen}
          onClose={handleCloseErrorDialog}
          message={errorMessage}
        />
      </WrapContent>
    </CrewStyle>
  );
}
